(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.tabbing = skyward.tabbing || {};

        function getFocusables(scopedContainer)
        {
            var container = $(scopedContainer);
            var focusables = container.find(":focusable").not("[readonly]");

            return focusables;
        }

        function setFocus(elementParam)
        {
            var element = $(elementParam);
            if (!element.length)
            {
                return;
            }
            // Give Element Focus
            element.focus();

            // Select All Text In Element
            // Number input not supported (https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange)
            if (element.is("input[type='text'], input[type='search'], input[type='url'], input[type='tel'], input[type='password'], textarea"))
            {
                var domElement = element[0];
                if (domElement.value.length > 0)
                {
                    domElement.setSelectionRange(0, domElement.value.length);
                }
            }
        }

        skyward.tabbing.focusAfter = function (selector, tabsFromElement)
        {
            if (skyward.global.mobileAccess)
            {
                return;
            }
            var element = $(selector);

            if (!element.length)
            {
                element = $(document.activeElement);
            }

            var skywardContentPanel = getSkywardContentPanel(element);
            var allFocusables = getFocusables(skywardContentPanel);

            if (allFocusables.length === 0)
            {
                return;
            }

            if (isNaN(parseInt(tabsFromElement)) || tabsFromElement < 0)
            {
                tabsFromElement = 1;
            }

            var sortedFocusablesByTabIndex = {};
            var elementsIndexInSortedFocusables;
            var elementsTabIndex = 0;

            allFocusables.each(function ()
            {
                var thisFocusable = $(this);
                var thisTabIndex = thisFocusable.attr("tabindex");
                if (thisTabIndex === undefined)
                {
                    thisTabIndex = 0;
                }

                if (thisTabIndex >= 0)
                {
                    if (!(sortedFocusablesByTabIndex[thisTabIndex]))
                    {
                        sortedFocusablesByTabIndex[thisTabIndex] = [];
                    }
                    if (element[0] == thisFocusable[0])
                    {
                        elementsIndexInSortedFocusables = sortedFocusablesByTabIndex[thisTabIndex].length;
                        elementsTabIndex = thisTabIndex;
                    }
                    sortedFocusablesByTabIndex[thisTabIndex].push(thisFocusable);
                }
            });

            var movesRemaining = tabsFromElement;
            var focusedElement;

            var indexOfNextFocus = elementsIndexInSortedFocusables + tabsFromElement;
            var elementsLeftInCollection = sortedFocusablesByTabIndex[elementsTabIndex].length;
            if (indexOfNextFocus < elementsLeftInCollection)
            {
                focusedElement = sortedFocusablesByTabIndex[elementsTabIndex][indexOfNextFocus];
                setFocus(focusedElement);
                return;
            }
            else
            {
                movesRemaining -= elementsLeftInCollection - elementsIndexInSortedFocusables;
            }
            var sortedFocusablesKeys = Object.keys(sortedFocusablesByTabIndex);
            var keyPosition = sortedFocusablesKeys.indexOf(elementsTabIndex + "");

            // go to the next collection of tab-indexed items and look for a match
            for (var n = ++keyPosition; n < sortedFocusablesKeys.length; n++)
            {
                var elementsInNextCollection = sortedFocusablesByTabIndex[sortedFocusablesKeys[n]].length;
                if (movesRemaining <= elementsInNextCollection)
                {
                    focusedElement = sortedFocusablesByTabIndex[sortedFocusablesKeys[n]][movesRemaining];
                    setFocus(focusedElement);
                    return;
                }
                else
                {
                    movesRemaining -= elementsInNextCollection;
                }
            }
            var defaultFocusedElement = sortedFocusablesByTabIndex[sortedFocusablesKeys[0]][0];
            setFocus(defaultFocusedElement);
        };

        skyward.tabbing.focusBefore = function (selector)
        {
            if (skyward.global.mobileAccess)
            {
                return;
            }

            var element = $(selector).get(0);
            var skywardContentPanel = getSkywardContentPanel(element);
            var focusables = getFocusables(skywardContentPanel);

            if (focusables.length === 0)
            {
                return;
            }

            var elementReceivingFocus = null;

            for (var x = 0; x < focusables.length; x++)
            {
                if (focusables[x] == element)
                {
                    elementReceivingFocus = (x == 0) ? focusables[focusables.length - 1] : focusables[x - 1];
                    setFocus(elementReceivingFocus);
                    break;
                }
            }
            if (elementReceivingFocus == null)
            {
                elementReceivingFocus = focusables[0];
                setFocus(elementReceivingFocus);
            }
        };

        function getSkywardContentPanel(selector)
        {
            var element = $(selector);
            return element.prop("nodeName") === "HTML" ? element.find(".skywardContentPanel").first() : skyward.window.getClosestContentPanel(element);
        }

        function init(selector, notifyDOMLoadType)
        {
            if (notifyDOMLoadType.skywardContentPanel)
            {
                if (selector !== "#detailsPanel")
                {
                    var skywardContentPanel = getSkywardContentPanel(selector);

                    if (skywardContentPanel.length)
                    {
                        var focusedElement = skywardContentPanel.find("[autofocus]").first();
                        if (!focusedElement.length)
                        {
                            var minValue = Number.POSITIVE_INFINITY;
                            var minItem;
                            getFocusables(skywardContentPanel).each(function ()
                            {
                                var val = parseInt(this.getAttribute("tabindex"), 10);
                                if (val > 0 && val < minValue)
                                {
                                    minItem = this;
                                    minValue = val;
                                }
                            });
                            if (minItem)
                            {
                                focusedElement = $(minItem);
                            }
                            else
                            {
                                focusedElement = null;
                            }
                        }

                        if (focusedElement && focusedElement.length)
                        {
                            setFocus(focusedElement);
                            focusedElement.select();
                        }
                    }
                }
            }

        }

        if (!skyward.global.mobileAccess)
        {
            skyward.window.registerLoadDOMCallback(init);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);